export class MaskedInput {
    private _currentContext: JQuery = $();

    private applyMask() : void {
        this._currentContext.inputmask();
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.applyMask();
    }

    // tslint:disable-next-line:member-ordering
    public static init(context: JQuery): MaskedInput {
        const maskedInput = new MaskedInput();
        maskedInput.init(context);
        return maskedInput;
    }
}
